import { render, staticRenderFns } from "./RoomTypeIntroduce.vue?vue&type=template&id=5a8f965e&scoped=true"
import script from "./RoomTypeIntroduce.vue?vue&type=script&lang=js"
export * from "./RoomTypeIntroduce.vue?vue&type=script&lang=js"
import style0 from "./RoomTypeIntroduce.vue?vue&type=style&index=0&id=5a8f965e&prod&lang=scss&scoped=true"
import style1 from "./RoomTypeIntroduce.vue?vue&type=style&index=1&id=5a8f965e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8f965e",
  null
  
)

export default component.exports